import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
    // token: process.env.REACT_APP_SANITY_TOKEN,
    projectId: process.env.SANITY_PRODUCT_ID || "d7zd2gsp",
    dataset: 'production',
    apiVersion: "2022-02-03",
    useCdn: 'true',
})
const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);